import type {
  ApiV1NotificationRegisterTokenPostRequest,
  ApiV1NotificationRemoveTokenPostRequest,
  NotificationApi,
} from '../generated'
import { createAPISlice } from './createAPISlice'

export default function createNotificationApis(
  notificationApi: NotificationApi,
) {
  return createAPISlice({
    registerToken: async (
      params: ApiV1NotificationRegisterTokenPostRequest,
    ) => {
      return await notificationApi.apiV1NotificationRegisterTokenPost(params)
    },
    removeToken: async (params: ApiV1NotificationRemoveTokenPostRequest) => {
      return await notificationApi.apiV1NotificationRemoveTokenPost(params)
    },
  })
}
